import script from "./HeaderPartnerAccount.vue?vue&type=script&setup=true&lang=js"
export * from "./HeaderPartnerAccount.vue?vue&type=script&setup=true&lang=js"

import "./HeaderPartnerAccount.vue?vue&type=style&index=0&id=d518be7c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d518be7c"]])

export default __exports__